import { useLayoutEffect, useState } from "react";

const TAB_BAR = '[data-slot="app-tab-bar"]';
/** The tab bar's bottom edge when the bar isn't mounted: the bar's own 36px. */
const FALLBACK = 36;

/**
 * The tab bar's bottom edge in viewport px, so a fixed panel can dock right
 * under it. Tracks banners above the bar appearing or closing.
 */
export function useTabBarBottom(enabled = true): number {
  const [bottom, setBottom] = useState(FALLBACK);
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const bar = document.querySelector<HTMLElement>(TAB_BAR);
    if (!bar) return undefined;
    const measure = () =>
      setBottom(Math.round(bar.getBoundingClientRect().bottom));
    measure();
    window.addEventListener("resize", measure);
    const ro =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(measure);
    if (bar.parentElement) ro?.observe(bar.parentElement);
    return () => {
      window.removeEventListener("resize", measure);
      ro?.disconnect();
    };
  }, [enabled]);
  return bottom;
}
